/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagecopyemail3Inputs */

const en_ticketpagecopyemail3 = /** @type {(inputs: Ticketpagecopyemail3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy email`)
};

const de_ticketpagecopyemail3 = /** @type {(inputs: Ticketpagecopyemail3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail kopieren`)
};

/**
* | output |
* | --- |
* | "Copy email" |
*
* @param {Ticketpagecopyemail3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagecopyemail3 = /** @type {((inputs?: Ticketpagecopyemail3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagecopyemail3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagecopyemail3(inputs)
	return de_ticketpagecopyemail3(inputs)
});
export { ticketpagecopyemail3 as "ticketPageCopyEmail" }